__turbopack_context__.v({
  "placeholder": "sQ9Mta_placeholder",
  "variant-base-container": "sQ9Mta_variant-base-container",
  "variant-base-content": "sQ9Mta_variant-base-content",
  "variant-base-no-result": "sQ9Mta_variant-base-no-result",
  "variant-base-option": "sQ9Mta_variant-base-option",
  "variant-base-options": "sQ9Mta_variant-base-options",
  "variant-base-root": "sQ9Mta_variant-base-root",
  "variant-input-container": "sQ9Mta_variant-input-container",
  "variant-input-content": "sQ9Mta_variant-input-content",
  "variant-input-no-result": "sQ9Mta_variant-input-no-result",
  "variant-input-option": "sQ9Mta_variant-input-option",
  "variant-input-options": "sQ9Mta_variant-input-options",
  "variant-input-root": "sQ9Mta_variant-input-root",
});
